<ng-template #loading>
  <boma-anim-spinning-loader
    [size]="40"
    style="display: inline-block"
  ></boma-anim-spinning-loader>
</ng-template>

<div *ngIf="loadedMapsApi; else loading">
  <div class="grid">
    <div class="col-12 md:col-6">
      <div class="border-round-xl p-0 overflow-hidden">
        <google-map
          #googleMap
          height="400px"
          width="auto"
          [center]="center"
          [zoom]="mapOptions.zoom"
          [options]="mapOptions"
          (mapClick)="mapClicked($event)"
          (mapDblclick)="mapDoubleClicked($event)"
        >
          <map-marker
            *ngFor="let marker of markers"
            [position]="marker.position"
            [label]="marker.label"
            [title]="marker.title"
            [options]="marker.options"
            (mapMouseup)="markerDragEnd($event)"
          ></map-marker>

          <map-marker
            *ngIf="location?.point?.coordinates"
            #currentLocation
            [position]="{
          lat: location.point.coordinates[1],
          lng: location.point.coordinates[0],
          }"
            [label]="location.name"
            [title]="location.name"
            [options]="{ draggable: false, animation: null }"
          ></map-marker>

          <map-polygon
            *ngIf="boundary"
            [paths]="boundary"
            [options]="polygonOptions"
            (click)="boundaryClick($event)"
          ></map-polygon>
        </google-map>
      </div>
      <div class="formgrid grid mt-2" *ngIf="update">
        <div class="field col-12 md:col-5">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">Lat</span>
            <p-inputNumber
              autocomplete="off"
              [(ngModel)]="userSelectedCoordinates.lat"
              inputId="lat"
              name="lat"
              mode="decimal"
              [min]="-90"
              [max]="90"
              [minFractionDigits]="0"
              [maxFractionDigits]="6"
            >
            </p-inputNumber>
          </div>
        </div>
        <div class="field col-12 md:col-5">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">Long</span>

            <p-inputNumber
              autocomplete="off"
              [(ngModel)]="userSelectedCoordinates.long"
              inputId="long"
              name="long"
              mode="decimal"
              [min]="-180"
              [max]="180"
              [minFractionDigits]="0"
              [maxFractionDigits]="6"
            >
            </p-inputNumber>
          </div>
        </div>
        <div class="field col-12 md:col-2">
          <button
            icon="material-icons-round mi-location-searching"
            type="button"
            pTooltip="Move Map to the Entered Long Lat Coordinates"
            (click)="findCoordinates()"
            class="bg-primary border-primary-500 w-100 px-3 py-2 text-base border-1 border-solid border-round cursor-pointer transition-all transition-duration-200 hover:bg-primary-600 hover:border-primary-600 active:bg-primary-700 active:border-primary-700"
          >
            Go
          </button>
        </div>
      </div>
      <div class="grid justify-content-center mt-2">
        <div class="flex align-items-center justify-content-between">
          <button
            *ngIf="allowEdit && !update"
            (click)="update = true"
            class="p-button p-button-primary"
            icon="material-icons-round mi-edit-location-alt"
            pButton
            pRipple
            label="Update Pin/Boundary"
            style="float: right"
          ></button>
          <ng-container *ngIf="update">
            <p-button
              (click)="setCurrentPosition()"
              class="ml-2"
              icon="material-icons-round mi-location-searching"
              iconPos="left"
              label="My Location"
              [disabled]="findingMe"
            ></p-button>

            <p-button
              *ngIf="allowDrawing && !pickerOnly"
              (click)="initDrawingManager()"
              class="ml-2"
              icon="material-icons-round mi-edit-location"
              iconPos="left"
              label="Draw Boundary"
            ></p-button>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6" *ngIf="location && !pickerOnly">
      <div
        class="col-12"
        *ngIf='location.usageType === "SalesAndDispatch" || location.usageType === "Dispatch" || location.usageType === 2 ||location.usageType === 3'
      >
        <div
          class="grid p-3 m-0 border-solid border-400 border-1 border-round-xl"
        >
          <div class="col-12">
            <p-divider>
              <div class="inline-flex align-items-center font-bold text-lg">
                <i class="material-icons-round mi-fence mr-2"></i>
                <b>
                  Distribution Geo-Fence:
                  <span *ngIf="location.isEntireCountry">Entire Country</span
                  ><span *ngIf="!location.isEntireCountry"
                    >Custom Boundary</span
                  ></b
                >
              </div>
            </p-divider>
          </div>

          <div class="col-12 md:col-6">
            <ng-container
              *ngIf="location.isEntireCountry && !this.drawingManager?.drawingMode"
            >
              <strong>This location is set to the entire country.</strong>
              <button
                *ngIf="allowDrawing"
                icon="material-icons-round mi-location-searching"
                type="button"
                pTooltip="Move Map to the Entered Long Lat Coordinates"
                (click)="initDrawingManager()"
                class="bg-primary border-primary-500 w-100 px-3 py-2 text-base border-1 border-solid border-round cursor-pointer transition-all transition-duration-200 hover:bg-primary-600 hover:border-primary-600 active:bg-primary-700 active:border-primary-700"
              >
                Set Custom Boundary
              </button>
            </ng-container>
            <ng-container *ngIf="this.drawingManager?.drawingMode"
              ><p>
                You can now Freely Draw your boundary on the map or select a
                province to use.
              </p>
            </ng-container>

            <ng-container *ngIf="!location.isEntireCountry">
              <p>The custom boundary is displayed on the map.</p>
            </ng-container>
          </div>
          <div class="col-12 md:col-6">
            <ng-container *ngIf="location.isEntireCountry">
              <!-- LETS SHOW EDIT BUTTON AND IF YOU EDIT YOU CAN THEN CHANGE THAT -->
            </ng-container>

            <ng-container *ngIf="this.drawingManager?.drawingMode">
              <p-dropdown
                [(ngModel)]="selectedCountryArea"
                [options]="countryAreas"
                appendTo="body"
                optionLabel="name"
                placeholder="Select Province as Geo Fence"
                (onChange)="setArea(selectedCountryArea.points)"
              >
              </p-dropdown>

              <p-button
                (click)="showDialogue()"
                icon="pi pi-external-link"
                label="Find Out More"
                styleClass="p-button-text p-button-info"
              ></p-button>
            </ng-container>

            <ng-container *ngIf="!location.isEntireCountry">
              <div class="align-center">
                <p-button
                  (click)="resetPolygon($event)"
                  pTooltip="The GeoFence will be set to the whole country."
                  label="Reset GeoFence to use Entire Country"
                  styleClass="p-button p-button-secondary"
                ></p-button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="col-12 mt-3" *ngIf="location">
        <div class="p-3 border-solid border-400 border-1 border-round-xl">
          <p-divider *ngIf="location.name">
            <div class="inline-flex align-items-center font-bold text-lg">
              <i class="material-icons-round mi-location-on mr-2"></i>
              <b> {{location.name}}</b>
            </div>
          </p-divider>

          <div class="form formgrid" *ngIf="editAddress">
            <form #editForm="ngForm" class="col-12">
              <label for="line1">Address Line 1</label>
              <input
                [(ngModel)]="newAddress.line1"
                (change)="emitPoint()"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="line1"
                name="line1"
                pInputText
                placeholder="Street Address"
                spellcheck="off"
                type="text"
              />

              <label for="line2">Address Line 2</label>
              <input
                [(ngModel)]="newAddress.line2"
                (change)="emitPoint()"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="line2"
                name="line2"
                pInputText
                placeholder="Unit, Suite, Floor etc."
                spellcheck="off"
                type="text"
              />
              <label *ngIf="editAddress" for="line4">Address Line 3</label>
              <input
                [(ngModel)]="newAddress.line4"
                (change)="emitPoint()"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="line4"
                name="line4"
                pInputText
                placeholder="Enter Suburb"
                spellcheck="off"
                type="text"
              />

              <label for="town">City / Town / Village</label>
              <input
                [(ngModel)]="newAddress.town"
                (change)="emitPoint()"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="town"
                name="town"
                pInputText
                placeholder="City / Town / Village"
                spellcheck="off"
                type="text"
              />
              <label for="province">Province / Region / State</label>
              <input
                [(ngModel)]="newAddress.province"
                (change)="emitPoint()"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="province"
                name="province"
                pInputText
                placeholder="Province"
                spellcheck="off"
                type="text"
              />
              <label for="postalcode">Postal Code / Zip Code</label>
              <input
                [(ngModel)]="newAddress.postalCode"
                (change)="emitPoint()"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="postalcode"
                name="postalcode"
                pInputText
                placeholder="Enter Postal Code"
                spellcheck="off"
                type="text"
              />
            </form>
          </div>

          <ng-container *ngIf="!editAddress && newAddress.province !== ''">
            <div class="grid mt-1">
              <div class="col font-bold">Address</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 1</div>
              <div class="col">{{newAddress?.line1}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 2</div>
              <div class="col">{{newAddress?.line2}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 3</div>
              <div class="col">{{newAddress?.line3}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 4</div>
              <div class="col">{{newAddress?.line4}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 5</div>
              <div class="col">{{newAddress?.line5}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Postal Code</div>
              <div class="col">{{newAddress?.postalCode}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Town</div>
              <div class="col">{{newAddress?.town}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Province</div>
              <div class="col">{{newAddress?.province}}</div>
            </div>
          </ng-container>

          <ng-container *ngIf="!editAddress && newAddress.province === ''">
            <div class="grid mt-1">
              <div class="col font-bold">Address</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 1</div>
              <div class="col">{{location.address?.line1}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 2</div>
              <div class="col">{{location.address?.line2}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 3</div>
              <div class="col">{{location.address?.line3}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 4</div>
              <div class="col">{{location.address?.line4}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Line 5</div>
              <div class="col">{{location.address?.line5}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Postal Code</div>
              <div class="col">{{location.address?.postalCode}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Town</div>
              <div class="col">{{location.address?.town}}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Province</div>
              <div class="col">{{location.address?.province}}</div>
            </div>
            <div class="grid mt-2">
              <div class="col">Latitude</div>
              <div class="col">{{ location?.point?.coordinates[1] }}</div>
            </div>
            <div class="grid mt-1">
              <div class="col">Longitude</div>
              <div class="col">{{ location?.point?.coordinates[0] }}</div>
            </div>

            <div *ngIf="!editAddress" class="field col-12">
              <p
                *ngIf="!newAddress?.postalCode|| !newAddress?.Suburb"
                class="mt-4"
              >
                Something not looking right?
                <a
                  (click)="editAddress = !editAddress;this.newAddress = this.location?.address"
                  class="cursor-pointer"
                  >Update it now</a
                >.
              </p>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="col-12 mt-3">
        <strong>Latitude:</strong> {{ latitude }}<br />
        <strong>Longitude:</strong> {{ longitude }}<br />
        <br />
        <ng-container>{{ this.newAddress?.line3 || '' }}</ng-container>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Using Maps"
  [(visible)]="help"
  [modal]="true"
  [style]="{width: '50vw'}"
>
  <p-carousel
    [circular]="true"
    [numScroll]="1"
    [numVisible]="1"
    [value]="helpSlides"
  >
    <ng-template let-slide pTemplate="item">
      <div class="slide-item text-center pt-2">
        <ng-container *ngIf="slide.video">
          <div [innerHTML]="slide.video"></div>
        </ng-container>
        <img [src]="slide.image" />
        <h3>{{ slide.title }}</h3>
        <div [innerHtml]="slide.text"></div>
      </div>
    </ng-template>
  </p-carousel>
</p-dialog>
